import React, { Component } from "react";
import { Marker } from "@vis.gl/react-google-maps";
import { connect } from "react-redux";

import { MAP_SPIDERFY, MARKER_SELECTING } from "../../../reducers/map";

// Collapsed representation of several drop points that share one location.
// Drawn as a CIRCLE badge (not a teardrop pin) so its count cannot be misread
// as a numbered sequence stop — a circle reads as "a group", not "stop #N".
class ClusterMarker extends Component {
  expand = () => {
    // Clear any open InfoWindow/selection from a previously expanded group so a
    // stale popup doesn't linger (or reappear) when switching clusters.
    this.props.MARKER_SELECTING(-1);
    this.props.MAP_SPIDERFY(this.props.groupKey);
  };

  render() {
    return (
      <Marker
        position={this.props.center}
        label={{
          text: String(this.props.count),
          color: "#ffffff",
          fontWeight: "bold",
          fontSize: "12px"
        }}
        icon={{
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 14,
          fillColor: "#7e57c2",
          fillOpacity: 1,
          strokeColor: "#ffffff",
          strokeWeight: 2
        }}
        onClick={this.expand}
      />
    );
  }
}

const mapActionsToProps = { MAP_SPIDERFY, MARKER_SELECTING };

export default connect(null, mapActionsToProps)(ClusterMarker);
